var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"wrap"},[_c('v-col',{attrs:{"md":"6"}},[_c('line-chart',{attrs:{"series":_vm.addSeries,"categories":_vm.days,"options":{
          title: {
            text: 'Activations',
            offsetX: 14,
          },
        },"id":"activation"}})],1),_c('v-col',{attrs:{"md":"6"}},[_c('line-chart',{attrs:{"series":_vm.renewSeries,"categories":_vm.days,"options":{
          title: {
            text: 'Renewals',
            offsetX: 14,
          },
        },"id":"renewal"}})],1),_c('v-col',{attrs:{"md":"6"}},[_c('line-chart',{attrs:{"series":_vm.paymentSeries,"categories":_vm.days,"id":"pay","options":{
          title: {
            text: 'Pay TM',
            offsetX: 14,
          },
        }}})],1),_c('v-col',{attrs:{"md":"6"}},[_c('line-chart',{attrs:{"series":_vm.paymentEasyBuzz,"categories":_vm.days,"id":"pay","options":{
          title: {
            text: 'Easy Buzz',
            offsetX: 14,
          },
        }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }